import { useEffect, useState } from "react";
import {
  Accordion
} from "react-bootstrap";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import SingleRecommendation from "./Components/SingleFullscriptRecommendation";
import AppDateRangePicker from "components/AppDateRangePicker/Index";
import { getFullscriptLabOrders } from "store/services/fullscriptService";
import * as actions from "store/actions";

const FullscriptRecommendations = ({
  dispatch,
  fullscriptConnection,
  fullscriptRecommendations,
  getFullscriptRecommendations,
  getRecommendationDetails,
  fullScriptCountry,
  // patientDetails,
  fullscriptWidgetRef,
}) => {
  const [patientDetails, setPatientDetails] = useState(null);
  const [fullscriptOrders, setFullscriptOrders] = useState(null);
  const [isReady, setReady] = useState(false);
  const { clientId } = useParams();
  
  useEffect(() => {
    if(fullscriptConnection) {
      getFullscriptRecommendations();
    }
  }, [fullscriptConnection]);

  useEffect(() => {
    if(!fullscriptWidgetRef?.current) {
      return;
    }

    const data = fullscriptWidgetRef.current && fullscriptWidgetRef.current.getFullscriptPatient()
    setPatientDetails(data);
  }, [fullscriptWidgetRef.current])

  useEffect(() => {
    if(!patientDetails?.id) {
      return;
    }

    getFullscriptLabOrdersList(patientDetails?.id)
  }, [patientDetails])

  const getFullscriptLabOrdersList = async (patientId) => {
    try {
      dispatch(actions.persist_store({ loader: true }));
      const response = await getFullscriptLabOrders(patientId);
      if(response?.body?.length) {
        setFullscriptOrders(response?.body);
      }
      dispatch(actions.persist_store({ loader: false }));
      setReady(true);
    } catch(err) {
      console.error("Error getting fullscript lab orders", err);
      dispatch(actions.persist_store({ loader: false }));
    }
  }

  return (
    <div className="mt-4 mb-3">
      <div className="d-flex justify-content-between align-items-center">
        <h6 className="m-0 fw-bold">
          Fullscript Recommendations
        </h6>
        <div>
          <AppDateRangePicker
            isClearable={true}
            onChange={getFullscriptRecommendations}
          />
        </div>
      </div>
      <Accordion className="ColoredAcorrdion">
        {isReady && fullscriptRecommendations?.length > 0 ? (
          fullscriptRecommendations.map(recommendation => {
            const order = fullscriptOrders?.length && fullscriptOrders.find(order => order.treatment_plan_id === recommendation.id);
            return (
              <SingleRecommendation
                key={recommendation.id}
                recommendation={recommendation}
                getDetails={getRecommendationDetails}
                getRecommendations={getFullscriptRecommendations}
                fullScriptCountry={fullScriptCountry}
                order={order}
              />
            )
          })
        ):(
          <p>No Fullscript recommendations found</p>
        )}
      </Accordion>
    </div>
  )
}



const mapStateToPros = (state) => {
  let fullscriptConnection = state.AccountSetting.integrations.find(integration => integration.connection_type == "full_script");
  return {
    fullscriptConnection,
    fullscriptRecommendations: state.Client.client.fullscriptRecommendations,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(FullscriptRecommendations);